// surveys.ts — Sondage de satisfaction (période d'évaluation).
// Soumission ouverte à tout utilisateur authentifié.
import { req } from './_internals.js';

export const surveysApi = {
  submitSurvey: (d: unknown) => req('POST', '/surveys', d),
};
